import { InputField, InputSelectOptions, LoaderButton } from 'components/molecules'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { SCOPE } from 'domains/outbound/deals/constants'

const propTypes = {
  filterValues      : PropTypes.object.isRequired,
  onClickSubmitForm : PropTypes.func.isRequired,
  onClickReset      : PropTypes.func.isRequired
}

const OutboundDealsFilterForm = ({ filterValues, onClickSubmitForm, onClickReset }) => (
  <Formik
    initialValues={{
      // separate bars (no free-text mix)
      name        : filterValues.name        || '',
      email       : filterValues.email       || '',
      phone       : filterValues.phone       || '',
      order_number: filterValues.order_number|| '',
      sku         : filterValues.sku         || '',
      scope       : filterValues.scope       || SCOPE.NEED_PACKING,
    }}
    enableReinitialize
    onSubmit={onClickSubmitForm}
  >
    {(formikProps) => (
      <Form>
        <ListGroup>

          <ListGroupItem>
            <InputField
              type="text"
              name="name"
              label="Customer Name"
              placeholder="Nama customer"
              bsSize="md"
            />
          </ListGroupItem>

          <ListGroupItem>
            <InputField
              type="text"
              name="email"
              label="Email"
              placeholder="Email"
              bsSize="md"
            />
          </ListGroupItem>

          <ListGroupItem>
            <InputField
              type="text"
              name="phone"
              label="Phone Number"
              placeholder="No. HP (UserDetail)"
              bsSize="md"
            />
          </ListGroupItem>

          <ListGroupItem>
            <InputField
              type="text"
              name="order_number"
              label="Order Number"
              placeholder="BNK..."
              bsSize="md"
            />
          </ListGroupItem>

          <ListGroupItem>
            <InputField
              type="text"
              name="sku"
              label="SKU (Item Dalam Deal)"
              placeholder="SKU terakhir / parsial"
              bsSize="md"
            />
          </ListGroupItem>

          <ListGroupItem>
            <InputField
              type="select"
              name="scope"
              label="Status"
              bsSize="md"
            >
              <InputSelectOptions options={SCOPE} />
            </InputField>
          </ListGroupItem>

          <div className="d-flex justify-content-center position-sticky fixed-bottom bg-white py-3">
            <LoaderButton
              color="primary"
              className="mt-auto"
              type="submit"
              disabled={formikProps.isSubmitting}
              isLoading={formikProps.isSubmitting}
              text="Filter"
            />
            <LoaderButton
              color="danger"
              disabled={formikProps.isSubmitting}
              isLoading={formikProps.isSubmitting}
              text="Reset"
              onClick={onClickReset}
            />
          </div>

        </ListGroup>
      </Form>
    )}
  </Formik>
)

OutboundDealsFilterForm.propTypes = propTypes
export default OutboundDealsFilterForm
